import Headline from 'components/headline';
import React from 'react';
import classnames from 'classnames';
import { CREDIT_CARD } from 'constants/userProfile';
import { formatText } from 'core/i18n';

export const IdentityHeadline = ({ singleIdentificationMethod, investmentType }) => {
    const [identityTitle, identityText] = singleIdentificationMethod || [
        formatText('stepsTitles-identityTitle'),
        formatText('stepsTitles-identityText'),
    ];
    const [title, content] =
        investmentType === CREDIT_CARD
            ? [formatText('stepsTitles-identityTitleCreditCard'), formatText('stepsTitles-identityTextCreditCard')]
            : [identityTitle, identityText];
    const classNamesHeadline = classnames('prospects-gutter', {
        'prospects-headline__single-option': singleIdentificationMethod,
    });

    return (
        <Headline icon="identificacion" className={classNamesHeadline}>
            <h2 id="identificacionTitle">{title}</h2>
            <p>{content}</p>
        </Headline>
    );
};
